import { render, staticRenderFns } from "./FiltrosDeListagemArticuladorMunicipal.vue?vue&type=template&id=574cb620"
import script from "./FiltrosDeListagemArticuladorMunicipal.vue?vue&type=script&lang=js"
export * from "./FiltrosDeListagemArticuladorMunicipal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports